import { render } from "./ServiceEinstellungen.vue?vue&type=template&id=2c0b162b&ts=true"
import script from "./ServiceEinstellungen.vue?vue&type=script&lang=ts"
export * from "./ServiceEinstellungen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__